//enabling "safe" scroll when closing drawer.
$(document).on('click','button[title="Close Cart"]',function(){ 
 $('html, body').addClass("safe-scrollenable"); 
});

// AF --> safe scroll on initial load
$(function(){
$('html, body').addClass("safe-scrollenable"); 
});

//removing safe scroll when drawer opens.
      document.addEventListener('drawerOpen', function() {
        {
           $('html, body').removeClass("safe-scrollenable"); 
        }
        
    });

//vh calc for all use cases, including cart fix.
function calculateVh() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
}

// Initial calculation
calculateVh();

// Re-calculate on resize
window.addEventListener('resize', calculateVh);

// Re-calculate on device orientation change
window.addEventListener('orientationchange', calculateVh);